<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content class="pt-2">
  <form [formGroup]="form">
    <odq-date-input badge="7" [placeholder]="data.dateInputPlaceholder" formControlName="date"></odq-date-input>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button color="primary" [mat-dialog-close]="form.get('date').value"
    [disabled]="form.invalid">{{'navigation.ok' | translate}}</button>
  <button mat-flat-button mat-dialog-close>{{'navigation.cancel' | translate}}</button>
</mat-dialog-actions>
